import { c as _c } from "react/compiler-runtime";
import { EntryList } from '../entry-list';
import { ENTRY_STATUS_LABELS, EntryInfo, EntryStatus } from '../utils';
import css from './entry-group.module.scss';
type EntryGroupProps = {
  status: EntryStatus;
  entries: EntryInfo[];
  open: boolean;
  onToggle: () => void;
};
export function EntryGroup(t0) {
  const $ = _c(19);
  const {
    status,
    entries,
    open,
    onToggle
  } = t0;
  if (entries.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className={css.statusDot} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = ENTRY_STATUS_LABELS[status];
  let t3;
  if ($[1] !== t2) {
    t3 = <span className={css.groupLabel}>{t2}</span>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== entries.length) {
    t4 = <span className={css.groupCount}>{entries.length}</span>;
    $[3] = entries.length;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className={css.groupChevron} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== onToggle || $[7] !== open || $[8] !== t3 || $[9] !== t4) {
    t6 = <button type="button" className={css.groupHeader} onClick={onToggle} aria-expanded={open}>{t1}{t3}{t4}{t5}</button>;
    $[6] = onToggle;
    $[7] = open;
    $[8] = t3;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== entries || $[12] !== open) {
    t7 = open && <div className={css.scrollArea}><EntryList entries={entries} /></div>;
    $[11] = entries;
    $[12] = open;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== open || $[15] !== status || $[16] !== t6 || $[17] !== t7) {
    t8 = <div className={css.groupBox} data-status={status} data-open={open}>{t6}{t7}</div>;
    $[14] = open;
    $[15] = status;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}